export default __webpack_public_path__ + "static/media/gannt-icon.d17edea3.svg";